import { useId, useState } from "react";
import type { FunctionComponent } from "react";
import cx from "clsx";
import { ChevronDown, ChevronRight, ChevronUp } from "../../svgs";
import { Transition } from "@headlessui/react";
import wcc_logo from "../../../assets/images/wcc_logo.svg";

import styles from "./styles.module.css";

const list = (
  <ul className="md:flex md:gap-x-[10px]">
    <li>
      <a
        href="https://www.westminster.gov.uk/residents"
        className={styles.topMenuItem}
        target="_blank"
        rel="noreferrer"
      >
        Residents
        <ChevronRight className="md:hidden" />
      </a>
    </li>
    <li>
      <a
        href="https://www.westminster.gov.uk/businesses"
        className={styles.topMenuItem}
        target="_blank"
        rel="noreferrer"
      >
        Businesses
        <ChevronRight className="md:hidden" />
      </a>
    </li>
    <li>
      <a
        href="https://www.westminster.gov.uk/portals"
        className={styles.topMenuItem}
        target="_blank"
        rel="noreferrer"
      >
        MyWestminster accounts
        <ChevronRight className="md:hidden" />
      </a>
    </li>
  </ul>
);

const Header: FunctionComponent = () => {
  const [open, setOpen] = useState(false);
  const id = useId();

  const toggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <header>
      <nav
        aria-label="Primary"
        className={cx(styles.headerNav, "w-full px-3 py-4")}
      >
        <div className="flex w-full items-center justify-between lg:container ">
          <a
            href="https://www.westminster.gov.uk"
            className="outline-link-focus-bg focus:bg-link-focus-bg"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={wcc_logo}
              className={styles.logo}
              alt="Westminster Gov HomePage"
            />
          </a>
          <button
            className="secondary-button flex items-center gap-2 rounded border-2 border-primary p-2 text-xl font-medium text-primary md:hidden"
            onClick={toggle}
            aria-controls={id}
            aria-expanded={open}
          >
            Menu
            {open ? (
              <ChevronUp className="icon-chevron" />
            ) : (
              <ChevronDown className="icon-chevron" />
            )}
          </button>

          <div className="hidden md:flex md:justify-end	">
            <div id={id}>{list}</div>
          </div>
        </div>
        <div className="md:hidden">
          <Transition
            show={open}
            as="div"
            className="grid overflow-hidden"
            enter="transition-[grid-template-rows] motion-reduce:transition-none duration-150"
            enterFrom="grid-rows-[0fr]"
            enterTo="grid-rows-[1fr]"
            leave="transition-all motion-reduce:transition-none duration-150"
            leaveFrom="grid-rows-[1fr]"
            leaveTo="grid-rows-[0fr]"
          >
            <div id={id} className="min-h-0">
              {list}
            </div>
          </Transition>
        </div>
      </nav>
    </header>
  );
};

export default Header;
